// src/components/Icons/Sources/OHIFLogo.tsx
import React, { useState } from 'react';
import type { IconProps } from '../types';
import androidPng from '../../../assets/android-chrome-192x192.png';

type Props = IconProps & {
  size?: number;
};

const OHIFLogo: React.FC<Props> = props => {
  const { size = 40, width, height, ...rest } = props as any;
  const w = width ?? size;
  const h = height ?? size;

  const [hover, setHover] = useState(false);

  return (
    <div
      role="img"
      aria-label="Central Imaging Service"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: 4,
        borderRadius: 8,
        transition: 'transform 140ms ease',
        transform: hover ? 'translateY(-2px)' : 'none',
        cursor: 'default',
      }}
    >
      <img
        src={androidPng}
        alt="Central Imaging Service"
        width={w}
        height={h}
        {...rest}
        style={{
          display: 'block',
          width: w,
          height: h,
          borderRadius: Math.max(6, Math.round(w * 0.18)),
          boxShadow: '0 4px 12px rgba(2, 6, 23, 0.12)',
          objectFit: 'cover',
          border: '1px solid rgba(2, 6, 23, 0.06)',
          background: '#fff',
          padding: 2,
        }}
      />

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            fontSize: 16,
            fontWeight: 700,
            fontFamily: 'Inter, Roboto, system-ui, -apple-system, "Segoe UI", sans-serif',
            color: '#ffffff',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 240,
            letterSpacing: '0.1px',
          }}
          title="Central Imaging Service"
        >
          Central Imaging Service
        </span>
      </div>
    </div>
  );
};

export default OHIFLogo;
